import { INote } from "models/notes";
import { useCentralApi, useCurrentUser } from "hooks/shared";

const useReadNote = () => {
    const user = useCurrentUser();
    const fetcher = useCentralApi(user);

    const handleRead = async (note: INote) => {
        const resp = await fetcher(`/api/v3/notes/${note.id}/read`, {
            method: 'PATCH'
        });
    };

    return handleRead;
};

export default useReadNote;